(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const controllers = new WeakMap();
    const initialize = (root) => {
      root.querySelectorAll('.adth-footer').forEach((footer) => {
        if (controllers.has(footer)) return;
        const row = footer.querySelector('.adth-footer__bottom-row');
        const localization = footer.querySelector('.adth-footer__localization');
        const menu = footer.querySelector('.adth-footer__links[data-footer-menu="help-support"]');
        const anchor = menu && (menu.querySelector('.head') || menu.querySelector('ul'));
        if (!row || !localization || !anchor) return;
        let frame = 0;
        const align = () => {
          frame = 0;
          if (!footer.isConnected || window.innerWidth < 768 || !anchor.getClientRects().length) {
            row.style.removeProperty('--footer-localization-leading-track');
            return;
          }
          const style = getComputedStyle(row);
          const paddingLeft = parseFloat(style.paddingLeft) || 0;
          const paddingRight = parseFloat(style.paddingRight) || 0;
          const gap = parseFloat(style.columnGap) || 0;
          const bounds = row.getBoundingClientRect();
          const available = bounds.width - paddingLeft - paddingRight - localization.offsetWidth - gap * 2;
          const desired = anchor.getBoundingClientRect().left - bounds.left - paddingLeft - gap;
          const paymentItem = row.querySelector('.adth-footer__payments svg, .adth-footer__payments img');
          const minimumTrailing = paymentItem ? Math.min(100, paymentItem.getBoundingClientRect().width) + gap : 0;
          if (desired < 0 || desired > available - minimumTrailing) {
            row.style.removeProperty('--footer-localization-leading-track');
            return;
          }
          const value = `${desired}px`;
          if (row.style.getPropertyValue('--footer-localization-leading-track') !== value) {
            row.style.setProperty('--footer-localization-leading-track', value);
          }
        };
        const schedule = () => {
          if (!frame) frame = requestAnimationFrame(align);
        };
        const observer = new ResizeObserver(schedule);
        observer.observe(row);
        footer.querySelectorAll('.adth-footer__block').forEach((block) => observer.observe(block));
        window.addEventListener('resize', schedule, { passive: true });
        footer.addEventListener('transitionend', schedule);
        footer.addEventListener('animationend', schedule);
        if (document.fonts) document.fonts.ready.then(schedule);
        controllers.set(footer, () => {
          observer.disconnect();
          cancelAnimationFrame(frame);
          window.removeEventListener('resize', schedule);
          footer.removeEventListener('transitionend', schedule);
          footer.removeEventListener('animationend', schedule);
          controllers.delete(footer);
        });
        schedule();
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.adth-footer').forEach((footer) => controllers.get(footer)?.());
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
